import { ListingDetails } from 'src/WebApiController';

import { ModalBodyDataContainer } from '../Modal/Modal.styled';
import { RetailSaleBuyerStep } from './components/RetailSaleBuyerStep';
import { RetailSaleCheckoutStep } from './components/RetailSaleCheckoutStep';
import {
  RetailSaleDetailActions,
  RetailSaleDetailView,
} from './components/RetailSaleDetailView';
import { RetailSaleStep } from './RetailSale';

type AdyenSession = {
  sessionId: string;
  sessionData: string;
  clientKey: string;
  environment: string;
  merchantReference: string;
};

type RetailSaleBodyProps = {
  listing?: ListingDetails;
  step: RetailSaleStep;
  saleId?: number | null;
  adyenSession: AdyenSession | null;
  showAdyenDropIn: boolean;
  onAdyenPaymentCompleted: (result: {
    resultCode: string;
    sessionResult?: string;
    billingAddress?: {
      street?: string;
      houseNumberOrName?: string;
      city?: string;
      stateOrProvince?: string;
      postalCode?: string;
      country?: string;
    };
    cardHolderName?: string;
  }) => void;
  onAdyenError: (error: { message: string }) => void;
  onAddNewCard: () => void;
  onDetailActionsReady?: (actions: RetailSaleDetailActions) => void;
};

export const RetailSaleBody = ({
  listing,
  step,
  saleId,
  adyenSession,
  showAdyenDropIn,
  onAdyenPaymentCompleted,
  onAdyenError,
  onAddNewCard,
  onDetailActionsReady,
}: RetailSaleBodyProps) => {
  return (
    <ModalBodyDataContainer>
      {step === 'buyer' ? (
        <RetailSaleBuyerStep listing={listing} />
      ) : step === 'detail' ? (
        <RetailSaleDetailView
          saleId={saleId ?? null}
          onActionsReady={onDetailActionsReady}
        />
      ) : (
        <RetailSaleCheckoutStep
          adyenSession={adyenSession}
          showAdyenDropIn={showAdyenDropIn}
          onAdyenPaymentCompleted={onAdyenPaymentCompleted}
          onAdyenError={onAdyenError}
          onAddNewCard={onAddNewCard}
        />
      )}
    </ModalBodyDataContainer>
  );
};
